export default __webpack_public_path__ + "static/media/lightNftCard.81ecf784.png";